import React from 'react'

if (process.env.REACT_APP_COMPONENT_NAVIGATION_CURRENCY_TOGGLE_LAYOUT === 'default') {
	require('../../../styles/css/components/currency/bk-flow-currency-toggle.css')
}

const BkFlowCurrencyToggleDefault = (props) => {
	const {
		currencyData,
		currencyEvent,
		currencyOptions,
		displayLabel,
		hotelLabels,
		isMobile,
	} = props

	return (
		<div className="bk-flow-currency-toggle default">
			{ displayLabel &&
				<label
					id={isMobile ? 'currencyAltLabel' : 'currencyLabel'}
					className="u-font-small u-font-bold"
					htmlFor={isMobile ? 'currencyAlt' : 'currency'}
				>
					{ hotelLabels.currency ? hotelLabels.currency : 'Currency' }
				</label>
			}

			<select
				className="u-form__select"
				name={ isMobile ? 'currencyAlt': 'currency' }
				onChange={ e => currencyEvent( e.target.value )}
				value={
					currencyData &&
					currencyData.currencyCode ? (
						currencyData.currencyCode
				)	: (
					'USD'
				)}
				tabIndex={ 0 }
				aria-labelledby={ isMobile ? 'currencyAltLabel': 'currencyLabel' }
			>
				{ currencyOptions }
			</select>
		</div>
	)
}



export default BkFlowCurrencyToggleDefault


// WEBPACK FOOTER //
// ./src/components/currency/layouts/BkFlowCurrencyToggleDefault.js